import styled from '@emotion/styled';
import { Grid, Typography } from '@material-ui/core';
import { Person } from '@material-ui/icons';
import { createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {
  rewardQuota: number;
  candidateCount: number;
  className?: string;
};

const OfferProposedCount: FC<Props> = ({ rewardQuota, candidateCount, className }) => {
  return (
    <Root className={className}>
      <Grid container direction="row" justify={'center'}>
        <IconGrid item xs={3}>
          <Icon />
        </IconGrid>
        <LabelGrid container item direction="column" xs={9} alignItems={'flex-start'}>
          <Grid item>
            <Label>
              <Text>
                <FormattedMessage id="offer_reward_quota_display.label.competition" />:
              </Text>
              <Quota>{rewardQuota}</Quota>
            </Label>
          </Grid>
          <Grid item>
            <Label>
              <Text>
                <FormattedMessage id="offer_proposal_display.label" />:
              </Text>
              <Quota>{candidateCount}</Quota>
            </Label>
          </Grid>
        </LabelGrid>
      </Grid>
    </Root>
  );
};

const Root = styled('div')({
  width: 'auto',
});

const IconGrid = styled(Grid)({
  display: 'table-cell',
  verticalAlign: 'middle',
  paddingTop: 5,
});

const LabelGrid = styled(Grid)({
  paddingLeft: 2,
});

const Icon = styled(Person)({
  marginRight: 6,
});

const Label = styled('div')({
  marginRight: '0.5em',
  fontSize: 12,
  fontWeight: 500,
  whiteSpace: 'nowrap',
  display: 'flex',
  alignItems: 'center',
});

const Text = styled(Typography)({
  marginRight: '0.5em',
  fontSize: 12,
  fontWeight: 500,
  whiteSpace: 'nowrap',
  display: 'flex',
  alignItems: 'center',
});

const Quota = styled(Typography)({
  fontWeight: 500,
  marginLeft: 5,
});

export default OfferProposedCount;
